import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import { Provider } from 'react-redux';
import '../assets/css/style.css';
import RouteHandler from './RouteHandler';
import store from './store';

function App() {
    return (
        <Provider store={store}>
            <RouteHandler />
        </Provider>
    );
}

export default App;
